import styled from "@emotion/styled";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { colors } from "@zfp-akademie-a-s/zfp-design";
import { InfoIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { Popper } from "Components/_Shared/Popper";
import type { RecommendedAmountLabel } from "Infrastructure/ApiZfp/Schema";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatCurrencyWithoutCode } from "Infrastructure/Utils/CurrencyUtils";
import { RECOMMENDED_AMOUNT_LABEL_TYPE_RESOURCE_KEY } from "Infrastructure/Utils/InsuranceUtils";
import { type FC, useState } from "react";

type Props = {
  readonly labels: RecommendedAmountLabel[];
};

const StyledWrapper = styled(Box)`
   ${({ theme }) => `
    width: ${theme.spacing(100)};
    background: ${colors.white};
    border-radius: ${theme.spacing(Radius.L)};
  `};
`;

export const RecommendedAmountsTooltip: FC<Props> = ({ labels }) => {
  const { t } = useResource();

  const [open, setOpen] = useState(false);

  return (
    <Popper
      isOpen={open}
      noPadding
      placement="top"
      onOpen={() => {
        setOpen(true);
      }}
      btnEl={
        <IconButton sx={{ padding: 0 }}>
          <InfoIcon htmlColor={colors.textSecondary} />
        </IconButton>
      }
    >
      <StyledWrapper boxShadow={2}>
        <Stack spacing={Spacing.M} paddingY={Spacing.L} paddingX={Spacing.XL}>
          {labels.map((label) => (
            <Box key={label.labelType} display="flex" justifyContent="space-between">
              <Typography variant="body2" color="text.secondary">
                {t(Resources.AnalysisDetail.Insurance.RecommendedAmountLabels[RECOMMENDED_AMOUNT_LABEL_TYPE_RESOURCE_KEY[label.labelType]])}
              </Typography>
              <Box display="flex">
                <Typography variant="body2" fontWeight={500}>
                  {formatCurrencyWithoutCode(label?.amount.value)}&nbsp;
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {t(Resources.Common.CZKSuffix)}
                </Typography>
              </Box>
            </Box>
          ))}
        </Stack>
      </StyledWrapper>
    </Popper>
  );
};
